import { render, staticRenderFns } from "./Unserved.vue?vue&type=template&id=428a44d7&"
import script from "./Unserved.vue?vue&type=script&lang=js&"
export * from "./Unserved.vue?vue&type=script&lang=js&"
import style0 from "./Unserved.vue?vue&type=style&index=0&id=428a44d7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports